import React, { useState } from 'react';
import { Container, Row } from 'react-bootstrap';
import Category from '../components/Category';
import ProjectsVideo from '../components/ProjectsVideo';
import BackArrow from '../components/BackArrow';

import '../css/projects.css';

import actingReel1 from '../img/acting-reel/jamie-sparker-acting-reel.jpg';

function ActingReel() {
  const [popupOn, setPopupOn] = useState(false);
  const [url, setUrl] = useState('');
  const [videoTitle, setVideoTitle] = useState('');
  const [description, setDescription] = useState('');

  return (
    <React.Fragment>
      <Container id='projects'>
        <BackArrow lastPage='/projects' />
        <Row className='projects-row'>
          <Category
            photo={actingReel1}
            title={`#1`}
            overlay={'0.1'}
            routable={false}
            popup={true}
            hover={true}
            setPopupOn={setPopupOn}
            video={true}
            url='https://www.youtube.com/embed/NAeIEoyP3Ew'
            videoTitle='Behind the mask'
            description={`Do you believe that a man under pressure will tell you the truth ?
            Am I saying the truth? A half-truth? Or am I lying all the time? For
            everyone out there, don't judge a book by its cover but try to get
            to know people instead. Our time is limited. So why should we waste
            it? And one last thing, you don't know me but you´re about to...`}
            setUrl={setUrl}
            setVideoTitle={setVideoTitle}
            setDescription={setDescription}
          />
        </Row>
      </Container>
      <ProjectsVideo
        video={true}
        videoTitle={videoTitle}
        description={description}
        url={url}
        popupOn={popupOn}
        setPopupOn={setPopupOn}
      />
    </React.Fragment>
  );
}

export default ActingReel;
